export const theme = {
  colors: {
    white: '#ffffff',
    black: '#000',
    green: '#27ae60',
    backgroundLightGrey: '#DFE1E6',
    tangerine: '#fd740d',
    lightTangerine: '#FFEBDC',
    backgroundLightBlue: '#f9fdfe',
    backgroundLightSilver: '#f8f9fB',
    backgroundDarkSilver: 'rgba(114, 111, 111, 0.65)',
    backgroundDark: '#485465',
    backgroundLightDark: '#868f9d',
    backgroundSilver: '#d5d6d6',
    backgroundSilverDark: '#e1ecef',
    backgroundDarkGray: '#a4a4a4',
    backgroundGray: '#f1f1f1',
    backgroundLightGray: '#fafafa',
    backgroundVeryLightGray: '#f2f2f2',
    backgroundGold: '#e67e22',
    tangerinePrimary: '#ff9900',
    tangerineSecond: '#fd6f0f',
    tangerineLight: '#FEF1E6',
    lightOrange: '#FCD2B5',
    red: '#f5203a',
    fontNavigation: '#595959',
    fontTangerine: '#fd740d',
    fontLightBlack: '#1B1B1B',
    fontBlack: '#131313',
    fontLightBlue: 'rgba(24, 61, 80, 0.62)',
    fontDark: '#485465',
    fontDarkBlue: '#183d50',
    fontSilverDark: '#4a4a4a',
    fontSilverPrimary: '#626262',
    fontSilverLight: '#999999',
    fontSmoke: '#aeaeae',
    fontSilver: '#adb6bb',
    fontSilverLighter: 'rgba(27, 27, 27, 0.4)',
    fontLinkHover: '#40a9ff',
    borderDarkBlue: '#183d50',
    borderSilver: '#bac1c6',
    borderSilverDark: '#979797',
    borderLightSilver: '#e8e8e8',
    statisticsLightSilver: '#DFE1E6',
    borderLightestSilver: 'rgba(27, 27, 27, 0.1)',
    borderOrange: '#f5a623',
    borderGray: '#d9d9d9',
    borderDarkGray: '#cacaca',
    borderBlue: '#1890ff',
    shadowSilver: 'rgba(0, 0, 0, 0.16)',
    shadowBlue: '#80BFFE',
    catskillWhite: '#F3F6FA',
    gullGray: '#97A3B4',
    geyser: '#DBE0E8',
    geyserDarken: '#ccd2dc',
    prussianBlue: '#002257',
    whiteLilac: '#EDEFF9',
    mainDark: '#2C2C2C',
    secondaryDark: '#808080',
    lightDark: '#ababab',
    orangeColor: '#FD7114',
    darkColor: '#333',
    grayColor: '#BACACE',
    darkGrayColor: '#6A6A6A',
    lightGreen: '#00D200',
    grey: '#ABABAB',
    lightGrey: '#f4f4f4',
    vividCerulean: '#00aff0',
    darkBlue: '#2867b2',
    veryLightGrey: '#f1f1f1',
    lightGreySilver: '#f6f6f6',
    carnation: '#ffe9d8',
    lightPink: '#ffebeb',
    lightRed: '#E95E5E',
    vividRed: '#FF3E1D',
    greyMedium: '#9E9E9E',
    table: {
      title: '#707070',
      hoverBg: '#E8F3FE',
      silverLighter: 'rgba(27, 27, 27, 0.6)',
      mercury: '#E6E6E6',
      shadow: 'rgba(0, 0, 0, 0.15)',
      activeCellBg: '#F3F9FE',
      activeCellBr: '#80BFFE',
    },
    scrollbar: {
      track: '#f1f1f1',
      thumb: '#f5a623',
      thumbHover: '#de9720',
    },
    tooltip: {
      labelDark: '#a5a6b5',
      labelPrimary: '#d1d2e1',
      labelLight: '#e7e8f9',
    },
    clientCharts: {
      customer: '#fd740d',
      budget: '#1890ff',
      lead: '#d8d8d8',
      lineChartBg: '#725CA4',
      lineChartGreen: '#329B4F',
    },
    priorities: {
      no: 'rgb(170, 170, 170)',
      low: 'rgb(46, 204, 113)',
      average: 'rgb(241, 196, 15)',
      high: 'rgb(231, 76, 60)',
    },
  },
  fonts: {
    primary: 'Rubik',
  },
};



// WEBPACK FOOTER //
// ./src/styles/theme.js